<i18n
  src="@/locales/views/service_provider/warehouse/movements/list_warehouses.yml"
  lang="yaml"
></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div class="bg-white shadow overflow-hidden sm:rounded-md" v-if="load_data">
    <ul role="list" class="divide-y divide-slate-200">
      <li v-for="warehouse in warehouses" :key="warehouse.id">
        <div
          href="#"
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToShowWarehouse(warehouse.id)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ warehouse.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <router-link
                  class="link"
                  :to="{
                    name: this.routeName('show_warehouse'),
                    params: {
                      service_provider_id: this.service_provider_id,
                      warehouse_id: warehouse.id,
                    },
                  }"
                >
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <loading-message v-else />
  <div></div>
</template>

<script>
import Requester from "@/views/service_provider/requesters/warehouse/movements/list_warehouses.js";

export default {
  name: "SPWarehouseMovementsListWarehouses",
  data() {
    return {
      warehouses: [],
      load_data: false,
    };
  },
  props: {
    service_provider_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.fetchListWarehouses())
    );
  },
  methods: {
    fetchListWarehouses: async function () {
      let response = await Requester.fetchWarehouses(this.service_provider_id);
      this.warehouses = response.data;
      this.load_data = true;
    },
    goToShowWarehouse: function (warehouse_id) {
      this.$router.push({
        name: this.routeName("show_warehouse"),
        params: {
          service_provider_id: this.service_provider_id,
          warehouse_id: warehouse_id,
        },
      });
    },
  },
};
</script>
